import React from 'react';
import {
  ExportCheckboxGroupOption,
  ExportCheckboxGroupOptions,
  ExportCheckboxGroupWrapper,
} from '../styled';
import { Checkbox, Divider } from 'antd';

export const ExportCheckboxGroup = (props: {
  title: string;
  groupKey: string;
  options: { value: string; label: string }[];
  selected: string[];
  onSelectedChange: (title: string, s: string[]) => void;
}) => {
  const { title, groupKey, options, selected, onSelectedChange } = props;

  const allChecked = options.length === selected.length;
  const indeterminate = selected.length > 0 && selected.length < options.length;

  const handleGroupCheckboxClick = () => {
    if (allChecked) {
      onSelectedChange(groupKey, []);
    } else {
      const allOptionValues = options.map((o) => o.value);
      onSelectedChange(groupKey, allOptionValues);
    }
  };

  const handleSingleCheckboxClick = (value: string) => {
    let newSelected = [...selected];
    if (selected.includes(value)) {
      newSelected = newSelected.filter((i) => i !== value);
    } else {
      newSelected.push(value);
    }
    onSelectedChange(groupKey, newSelected);
  };

  return (
    <ExportCheckboxGroupWrapper>
      <Checkbox
        checked={allChecked}
        indeterminate={indeterminate}
        onClick={handleGroupCheckboxClick}
      >
        {title}
      </Checkbox>
      <Divider style={{ margin: '8px 0' }} />
      <ExportCheckboxGroupOptions>
        {options.map((op) => (
          <ExportCheckboxGroupOption key={op.value}>
            <Checkbox
              checked={selected.includes(op.value)}
              onClick={() => handleSingleCheckboxClick(op.value)}
            >
              {op.label}
            </Checkbox>
          </ExportCheckboxGroupOption>
        ))}
      </ExportCheckboxGroupOptions>
    </ExportCheckboxGroupWrapper>
  );
};
